module.exports = __webpack_public_path__ + "credito-10-d-3nn.png";